import { updateDoc } from 'firebase/firestore';

import getProcessLogRef from './getProcessLogRef';

export default function updateProcessLog(processLogId, data) {
  return updateDoc(getProcessLogRef(processLogId), data);
}
